import { ISubscription } from "../../../../models/Subscription";
import React, { useState } from "react";
import styles from "./SubscriptionItem.module.scss";
import { useTranslation } from "react-i18next";
import SubscriptionPopup from "../SubscriptionPopup/SubscriptionPopup";
import ConfirmPopup from "../../../../components/ConfirmPopup/ConfirmPopup";
import { openSuccessMessage } from "../../../../store/message/messageSlice";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../assets/images/icons/edit-dark.svg";
import deleteIcon from "../../../../assets/images/icons/delete-red.svg";
import { handleError } from "../../../../helper/errorHandler";
import { getSubscriptionDurationType } from "../../../../helper/getSubscriptionDurationType";
import { useSubscriptionMutations } from "../../../../api/mutations";

interface ISubscriptionItemProps {
  item: ISubscription;
}

const SubscriptionItem: React.FC<ISubscriptionItemProps> = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState<boolean>(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState<boolean>(false);
  const [showMore, setShowMore] = useState<boolean>(false);

  const { deleteSubscription } = useSubscriptionMutations();

  const clickOnEdit = () => {
    setShowSubscriptionPopup(true);
  };

  const clickOnDelete = () => {
    setShowConfirmPopup(true);
  };

  const onClickYes = () => {
    deleteSubscription(item.id, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("SubscriptionDeletedSuccessfully")));
        navigate(`/subscriptions/?shouldUpdateSubscriptions=${true}`);
      },
      onError: (e) => handleError(e, dispatch, t),
    });
  };

  const onClickNo = () => {
    setShowConfirmPopup(false);
  };

  const changeShowMoreVisible = () => {
    setShowMore(!showMore);
  };

  return (
    <div className={`${styles.item} ${item.isTrial && styles.trial}`}>
      <p className={styles.name}>{item.name}</p>
      <p className={styles.price}>€{item.price}</p>
      <p className={styles.credit}>
        {item.credits} {t("Credits")}
      </p>
      <p className={styles.duration}>
        {item.duration} {getSubscriptionDurationType(item.durationType, item.duration, t)}
      </p>
      {item.description.length > 28 && !showMore ? (
        <div>
          <p className={styles.description}>
            {item.description.slice(0, 22)}{" "}
            <button onClick={changeShowMoreVisible} className={styles.showMore}>
              {t("ShowMore")}..
            </button>
          </p>
        </div>
      ) : (
        <>
          <p className={styles.description}>{item.description}</p>
          {showMore && (
            <div className={styles.showMoreWrapper}>
              <button onClick={changeShowMoreVisible} className={styles.showMore}>
                {t("ShowMore")}
              </button>
            </div>
          )}
        </>
      )}
      <div className={styles.bottom}>
        <button className={`${styles.btn} ${styles.edit}`} onClick={clickOnEdit}>
          <img src={editIcon} alt={"edit"} />
          {t("Edit")}
        </button>
        <button className={`${styles.btn} ${styles.delete}`} onClick={clickOnDelete}>
          <img src={deleteIcon} alt={"delete"} />
          {t("Delete")}
        </button>
      </div>
      {showSubscriptionPopup && (
        <SubscriptionPopup setShowCreatePopup={setShowSubscriptionPopup} item={item} />
      )}
      {showConfirmPopup && (
        <ConfirmPopup
          title={t("AreYouSureYouWantToDeleteThisSubscription")}
          onClickYes={onClickYes}
          onClickNo={onClickNo}
        />
      )}
    </div>
  );
};

export default SubscriptionItem;
